import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export interface ViewTab<T extends string> {
  id: T;
  label: string;
  to: string;
}

/**
 * Views of one page as route links (not an in-page tab panel), so each
 * view has its own URL: Walkthroughs "Runs | Builds", Findings
 * "Queue | Hotspots".
 */
export function ViewTabs<T extends string>({
  label,
  tabs,
  current,
}: {
  label: string;
  tabs: ReadonlyArray<ViewTab<T>>;
  current: T;
}) {
  return (
    <nav aria-label={label} className="border-b border-border">
      <ul className="flex gap-6">
        {tabs.map((tab) => {
          const active = tab.id === current;
          return (
            <li key={tab.id}>
              <Link
                to={tab.to}
                aria-current={active ? "page" : undefined}
                className={cn(
                  "-mb-px inline-flex h-9 items-center border-b-2 text-sm font-medium",
                  active
                    ? "border-foreground text-foreground"
                    : "border-transparent text-muted-foreground hover:text-foreground",
                )}
              >
                {tab.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
